<template>
  <a
    href="https://2brain.com.br/"
    target="_blank"
    rel="noopener noreferrer"
    class="ui-nav-badge"
  ><slot>uma plataforma 2Brain</slot></a>
</template>

<script setup>
</script>

<style scoped>
.ui-nav-badge {
  display: inline-flex;
  align-items: center;
  font-family: var(--font-brand);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--muted);
  background: var(--navy-card);
  border: 1px solid var(--navy-border);
  border-radius: var(--r-pill);
  padding: 4px 10px;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s, border-color 0.2s;
}

.ui-nav-badge:hover {
  color: var(--cyan);
  border-color: var(--cyan);
}
</style>
